var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M15.2 1.5C15.2 0.947715 14.7523 0.499999 14.2 0.499999L5.20001 0.5C4.64773 0.5 4.20001 0.947715 4.20001 1.5C4.20001 2.05228 4.64773 2.5 5.20001 2.5L13.2 2.5L13.2 10.5C13.2 11.0523 13.6477 11.5 14.2 11.5C14.7523 11.5 15.2 11.0523 15.2 10.5L15.2 1.5ZM1.90712 15.2071L14.9071 2.20711L13.4929 0.792893L0.492905 13.7929L1.90712 15.2071Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLink);
export default __webpack_public_path__ + "static/media/ArrowLink.fbfffc8c6eef3b2e1f35176ceb150c96.svg";
export { ForwardRef as ReactComponent };